import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();
const API_CONTENT_TOKEN = process.env.VUE_APP_CONTENT_TOKEN;

export class RegistrationService {
    constructor() {
    }

    login(credentials) {
        const uri = `/api/auth/signin`;
        return apiHelper.login(uri, credentials);
    }

    getLoginPageNotification() {
        const uri = `/api/faq/getLoginPageNotification`;
        return apiHelper.get(uri);
    }
    loginAudit() {
        const uri = `/api/dashboard/redirection`;
        return apiHelper.get(uri);
    }
    verifyEmail(userName) {
        const uri = `/api/mail/activate/${userName}`;
        return apiHelper.post(uri);
    }
    getCountries() {
        const uri = `/api/country/registration`;
        return apiHelper.get(uri);
    }
    getNationalId(countryCode) {
        const uri = `/api/country-identity-card/country-code?countryCode=${countryCode}`;
        return apiHelper.get(uri);
    }
    getBussiness(companyCode) {
        const uri = `/api/business-category/primary-business/company-code/${companyCode}`;
        return apiHelper.get(uri);
    }
    registerPartner(form) {
        const uri = `/api/partner/register`;
        return apiHelper.post(uri, form);
    }
    emailOTPsend(form) {
        const uri = `/api/sendOtp/email`;
        return apiHelper.post(uri, form);
    }    
    emailOTPVerify(form) {
        const uri = `/api/email/otp/verify`;
        return apiHelper.post(uri, form);
    }    
    getPartnerList() {
        const uri = `/api/company`;
        return apiHelper.get(uri);
    }
    getPartnerAvailableList(pid) {
        const uri = `/api/companyMapping/companyAndCategory`;
        return apiHelper.get(uri);
    }    
    getPartnerExistingCompanyList(pid) {
        const uri = `/api/companyMapping/company/history`;
        return apiHelper.get(uri);
    }    
    getAvailableCategories(pid,companyCode){
        const uri = `/api/companyMapping/defaultCompanyDetails/partnerId/${pid}/companyCode/${companyCode}`;
        return apiHelper.get(uri);        
    }
    saveNewProfile(data) {
        const uri = `/api/companyMapping/addCompany`;
        return apiHelper.post(uri,data)
    }
    
    getOTPbyloginName(loginName) {
        const uri = `/api/sms/${loginName}`;
        return apiHelper.post(uri)
    }
    verifyOTP(data) {
        const uri = `/api/sms/verify`;
        return apiHelper.post(uri, data)
    }
    verifyLoginOTP(loginName) {
        const uri = `/api/sms/login-sms?loginName=${loginName}`;
        return apiHelper.get(uri)
    }
    resendOTP(loginName, smsCode) {
        // api / sms / resend / { loginName } / sms - code / { smsCode }
        const uri = `/api/sms/resend-otp?login-name=${loginName}&sms-code=${smsCode}`
        return apiHelper.get(uri)
    }
    getTerms(companyCode, categoryCode) {
        const uri = `/api/business-terms/company-code/category-code?companyCode=${companyCode}&categoryCode=${categoryCode}`;
        return apiHelper.get(uri);
    }
    getPrimaryCategoryListmapped(categoryCode,data) {
        const uri = `/api/business-category/categories/category-code/mapped?categoryCode=` + categoryCode;
        return apiHelper.post(uri,data);
    }
    getPrimaryCategoryList(categoryCode) {
        const uri = `/api/business-category/categories/category-code?categoryCode=` + categoryCode;
        return apiHelper.get(uri);
    }
    getPrimarySubCategories(categories) {
        const uri = `/api/business-category/sub-categories/category-code?categoryCode=` + categories;
        return apiHelper.get(uri);
    }
    getSecondarySubCategories(categories) {
        const uri = `/api/business-category/sub-categories/category-code?categoryCode=` + categories;
        return apiHelper.get(uri);
    }
    userNameUniquness(userName) {
        const uri = `/api/user/verify/` + userName;
        return apiHelper.get(uri);
    }
    checkIdentityCard(idValue, idType) {
        const uri = "/api/identity-card/validate/identity-card/long-desc?identityCard=" + idValue + "&longDesc=" + idType;
        return apiHelper.get(uri)
    }
    mobileNumberUniqueness(mobileNumber) {
        const uri = `/api/partner/validate/mobile-number/${mobileNumber}`;
        return apiHelper.get(uri)
    }
    emailUniqueness(email) {
        const uri = `/api/partner/validate/email/${email}`
        return apiHelper.get(uri);
    }
    restrictEmail(email) {
        const uri = `/api/control-parameter/email/${email}`
        return apiHelper.get(uri);
    }
    checkDunsCode(code) {
        const uri = `/api/partner/verify/duns-number/${code}`
        return apiHelper.get(uri);
    }
    userCategoryAudit(categoryCode, companyCode) {
        const uri = `/api/user-category-audit/category-code/${categoryCode}/company-code/${companyCode}`
        return apiHelper.post(uri)
    }
    //Whistle Blowing Policy Declaration
    getWhistleBP() {
        const uri = `/api/getWbpDeclaration`;
        return apiHelper.get(uri);
    }
    getWhistleBPContent(declarationName) {
        const uri = `/api/declarationName/${declarationName}`;
        return apiHelper.get(uri);
    }
    setWhistleBP(data) {
        const uri = `/api/setWbpDeclaration`
        return apiHelper.post(uri,{"declarationTag": "Y"})
    }
    
    setUtDecl(data) {
        const uri = `/api/setUtDeclaration`
        return apiHelper.post(uri,{"declarationTag": "Y"})
    }

    getUTDecl() {
        const uri = `/api/getUtDeclaration`;
        return apiHelper.get(uri);
    }
    getDeclarationContent(declarationName) {
        const uri = `/api/declarationName/${declarationName}`;
        return apiHelper.get(uri);
    }
    docInfo() {
        const uri = "/api/documents/get";
        return apiHelper.get(uri)
    }
    // /api/getCategories
    // long description

    emailVerification(email, userName) {
        const uri = `/api/user/email/activation?email-id=${email}&user-name=${userName}`
        return apiHelper.post(uri)
    }
    
    savePartnerQuery(data,source) {
        const uri = `/api/partnerqueries/vfacing/insertPartnerQueryEntry?source=${source}`
        return apiHelper.post(uri,data)
    }

    insertChatMessage(data) {
        const uri = `/api/partnerqueries/vfacing/insertChatMessage`
        return apiHelper.post(uri,data)
    }

    
    setResolved(data) {
        const uri = `/api/partnerqueries/vfacing/setResolved`
        return apiHelper.post(uri,data)
    }
    
    getPartnerQueries(partnerId) {
        const uri = `/api/partnerqueries/vfacing/getPartnerQueries?partnerId=${partnerId}`;
        return apiHelper.get(uri) 
    }
    getAllPartnerQueryList(currentpage, currentperpage, searchTerm, jobCode, userId, encCompanyCode) {
        const uri = `/api/partnerqueries/getAllPartnerQueryList?pageNo=${currentpage}&pageSize=${currentperpage}&searchTerm=${searchTerm}&jobCode=${jobCode}&userId=${userId}&encCompanyCode=${encCompanyCode}`;
        return apiHelper.get(uri)
    }
    getAllPartnerQueryListWithEmail(id) {
        const uri = `/api/partnerqueries/vfacing/getAllPartnerQueryListWithId/${id}`;
        return apiHelper.get(uri)
    }
    getPartnerQueryAdminApplicable(companyCode, eipUserId) {
        const uri = `/api/common-view/isPartnerQueriesRequired?encCompanyCode=${companyCode}&eipUserId=${eipUserId}`;
        return apiHelper.get(uri);
    }
}